(
    function (skyward, $, undefined)
    {
        "use strict";

        var init = function ()
        {
            setEvents();
            initialLoad.start();
        };

        var setEvents = function ()
        {
            $(document).ajaxSend(ajaxProcessor.requestSent)
                .ajaxComplete(ajaxProcessor.requestComplete)
                .on('showLoadingIndicator', stateManager.startManualOverride)
                .on('hideLoadingIndicator', stateManager.completeManualOverride);
        };

        const classNames =
        {
            initialLoad: "initialLoad",
            loading: "loading",
            longLoad: "longLoad"
        };

        var stateManager = (function ()
        {
            var noGlassClassname = "noGlass";
            var activityWaitDelay = 100;
            var initialLoadComplete = false;
            var waitingForActivity = false;
            var isManualOverride = false;
            var activityWaitTimer;

            var completeActivity = function ()
            {
                if (!stateManager.domReady || waitingForActivity || isManualOverride || !initialLoadComplete)
                {
                    return;
                }

                ajaxActivity.complete();
            };

            return { //bracket must be on same line as return statement 

                startTime: new Date().getTime(),

                domReady: false,

                startActivity: function ()
                {
                    window.clearTimeout(activityWaitTimer);

                    if (initialLoadComplete)
                    {
                        ajaxActivity.start();
                    }
                },

                /* debounce activity complete */
                waitForActivity: function ()
                {
                    window.clearTimeout(activityWaitTimer);

                    waitingForActivity = true;

                    activityWaitTimer = window.setTimeout(function ()
                    {
                        waitingForActivity = false;
                        completeActivity();
                    }, activityWaitDelay);
                },

                toggleGlass: function (showGlass)
                {
                    var localShowGlass = showGlass === undefined ? element.hasClass(noGlassClassname) : showGlass;

                    element.toggleClass(noGlassClassname, !localShowGlass);
                },

                startManualOverride: function ()
                {
                    isManualOverride = true;
                    manualOverride.start();
                },

                completeManualOverride: function ()
                {
                    isManualOverride = false;
                    manualOverride.complete();
                },

                forceComplete: function ()
                {
                    initialLoadComplete = true;
                    isManualOverride = false;
                    waitingForActivity = false;
                    initialLoad.complete();
                    ajaxActivity.complete();
                    manualOverride.complete();
                },
                completeInitialLoad: function ()
                {
                    initialLoadComplete = true;
                }
            };
        })();

        var element = (function ()
        {
            var indicatorId = "LoadingIndicator";
            var indicatorElement;

            var getElement = function () 
            {
                if (typeof indicatorElement === "undefined")
                {
                    indicatorElement = $('#' + indicatorId);
                }
                return indicatorElement;
            };

            return { //bracket must be on same line as return statement 
                addClass: function (className)
                {
                    getElement().addClass(className);
                },

                removeClass: function (className)
                {
                    getElement().removeClass(className);
                },

                toggleClass: function (className, toggle)
                {
                    getElement().toggleClass(className, toggle);
                },

                hasClass: function (className)
                {
                    return getElement().hasClass(className);
                },

                setAttribute: function(attr, val)
                {
                    getElement().attr(attr, val);
                }
            };
        })();

        var ajaxProcessor = (function ()
        {
            var defaultActivityIndicatorSettings =
            {
                silent: false,
                hideGlass: false
            };

            var openRequests = 0;
            var numActivitiesWithGlass = 0;

            return {  //bracket must be on same line as return statement 
                requestSent: function (event, xhr, settings)
                {
                    var localSettings = $.extend({}, defaultActivityIndicatorSettings, settings.activityIndicator);
                    if (localSettings.silent)
                    {
                        return;
                    }
                    if (!localSettings.hideGlass)
                    {
                        numActivitiesWithGlass++;
                    }

                    openRequests++;

                    var showGlass = numActivitiesWithGlass !== 0;
                    stateManager.toggleGlass(showGlass);

                    stateManager.startActivity();
                },

                requestComplete: function (event, xhr, settings)
                {
                    var localSettings = $.extend({}, defaultActivityIndicatorSettings, settings.activityIndicator);
                    if (localSettings.silent)
                    {
                        return;
                    }

                    openRequests = Math.max(openRequests - 1, 0); // requestComplete may have been called without requestSent
                    
                    if (!localSettings.hideGlass)
                    {
                        numActivitiesWithGlass = Math.min(Math.max(numActivitiesWithGlass - 1, 0), openRequests);
                    }

                    var hideGlass = numActivitiesWithGlass === 0;
                    stateManager.toggleGlass(!hideGlass);

                    if (!ajaxProcessor.hasOpenRequest())
                    {
                        stateManager.waitForActivity();
                    }
                },

                hasOpenRequest: function ()
                {
                    return openRequests > 0;
                },

                get openRequests()
                {
                    return openRequests;
                },

                get numActivitiesWithGlass()
                {
                    return numActivitiesWithGlass;
                },
            };
        })();

        var initialLoad = (function ()
        {
            var longActivityThreshold = 1600;

            var checkActivityThreshold = function ()
            {
                return new Date().getTime() - stateManager.startTime > longActivityThreshold;
            };

            return {  //bracket must be on same line as return statement 
                start: function ()
                {
                    $('body').on('keydown', preventTabWhileLoading);
                    longLoad.startTimer();

                    $(function ()
                    {
                        stateManager.domReady = true;
                        if (window.performance && typeof window.performance.mark === "function")
                        {
                            window.performance.mark("initialLoadComplete");
                        }
                        initialLoad.complete();
                        stateManager.completeInitialLoad();
                        if (ajaxProcessor.hasOpenRequest())
                        {
                            ajaxActivity.start();
                        }
                    });
                },

                complete: function ()
                {
                    const body = $('body');
                    body.off('keydown', preventTabWhileLoading);
                    body.attr('aria-live', true);

                    updateElementLoad(classNames.initialLoad, false);
                    doneLoading(checkActivityThreshold());
                }
            };

            function preventTabWhileLoading(e)
            {
                if (skyward.keys.getKeyNamesFromEvent(e)?.TAB) 
                { 
                    e.stopPropagation();
                    e.preventDefault();                
                }         
            }
        })();

        var manualOverride = (function ()
        {
            var longActivityThreshold = 600;
            var overrideStartTime;

            var checkActivityThreshold = function ()
            {
                return new Date().getTime() - overrideStartTime > longActivityThreshold;
            };

            return {  //bracket must be on same line as return statement 
                start: function ()
                {
                    overrideStartTime = new Date().getTime();
                    updateElementLoad(classNames.loading, true);
                    longLoad.startTimer();
                },

                complete: function ()
                {
                    updateElementLoad(classNames.loading, false);
                    doneLoading(checkActivityThreshold());
                }
            };
        })();

        var ajaxActivity = (function ()
        {
            var longActivityThreshold = 600;
            var ajaxStartTime;

            var checkActivityThreshold = function ()
            {
                return new Date().getTime() - ajaxStartTime > longActivityThreshold;
            };

            return {  //bracket must be on same line as return statement                   
                start: function ()
                {
                    if (element.hasClass(classNames.loading))
                    {
                        return;
                    }

                    ajaxStartTime = new Date().getTime();
                    updateElementLoad(classNames.loading, true);
                    longLoad.startTimer();
                },

                complete: function ()
                {
                    updateElementLoad(classNames.loading, false);
                    doneLoading(checkActivityThreshold());
                }
            };
        })();

        var longLoad = (function ()
        {
            var longLoadTimer;
            var longLoadDelay = 25000;

            return {  //bracket must be on same line as return statement 
                startTimer: function ()
                {
                    window.clearTimeout(longLoadTimer);
                    longLoadTimer = window.setTimeout(function ()
                    {
                        updateElementLoad(classNames.longLoad, true);
                    }, longLoadDelay);
                },

                complete: function ()
                {
                    window.clearTimeout(longLoadTimer);
                    updateElementLoad(classNames.longLoad, false);
                }
            };
        })();

        var doneLoading = (function ()
        {
            var doneLoadingTimer;
            var animationDuration = 300;
            var className = "done";

            return function (shouldAnimate)
            {
                window.clearTimeout(doneLoadingTimer);

                longLoad.complete();

                if (!shouldAnimate)
                {
                    element.removeClass(className);
                }
                else
                {
                    element.addClass(className);

                    doneLoadingTimer = window.setTimeout(function ()
                    {
                        element.removeClass(className);
                    }, animationDuration);
                }
            };
        })();         

        var gatherDataForError = function ()
        {
            return {
                openRequests: ajaxProcessor.openRequests, numActivitiesWithGlass: ajaxProcessor.numActivitiesWithGlass
            };
        };

        /* This is needed for browsers that support bfcache (back/forward cache). */
        window.onpageshow = function (event)
        {
            /* hide the indicator if the page loaded from cache */
            if (event.persisted)
            {
                stateManager.forceComplete();
            }
        };

        function updateElementLoad(className, isStarting)
        {
            element.toggleClass(className, isStarting);
            $('body').attr("aria-busy", isStarting)
        }

        skyward.error.registerErrorDataGatherer("activityindicator", gatherDataForError);
        init();

    }(window.skyward = window.skyward || {}, window.jQuery)
);
